import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { Stack, IconButton, InputAdornment, TextField, Link } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { useSnackbar } from 'notistack';
import Iconify from '../../../components/iconify';
import axiosInstance from '../../../utils/axiosInstance';

// ----------------------------------------------------------------------

export default function SignUpForm() {
  const navigate = useNavigate();
  const usernameRef = useRef();
  const passwordRef = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const [showPassword, setShowPassword] = useState(false);

  const handleClick = () => {
    const jsonData = {
      username: usernameRef.current.value,
      password: passwordRef.current.value,
    };
    axiosInstance
      .post(`${window.location.protocol}//${window.location.host}/api/user/new`, jsonData)
      .then(async () => {
        enqueueSnackbar(`Success - Signed up user ${usernameRef.current.value}`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      })
      .catch((error) => {
        if (error.response.data == null)
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        else
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
      });
  };

  return (
    <>
      <Stack spacing={3} pb={3}>
        <TextField name="email" label="Username" inputRef={usernameRef} />
        <TextField
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          inputRef={passwordRef}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Stack direction="row" spacing={3}>
          <Link
            sx={{ cursor: 'pointer' }}
            variant="subtitle2"
            onClick={() => {
              navigate('/login', { replace: true });
            }}
          >
            Log in
          </Link>
          <Link
            sx={{ cursor: 'pointer' }}
            variant="subtitle2"
            onClick={() => {
              navigate('/', { replace: true });
              window.location.reload();
            }}
          >
            Dashboard
          </Link>
        </Stack>
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleClick}>
        Sign up
      </LoadingButton>
    </>
  );
}
